const isObject = (value) =>
  Boolean(value) && typeof value === "object" && !Array.isArray(value);

const firstNonEmpty = (...values) =>
  values.find(
    (value) =>
      value !== undefined && value !== null && String(value).trim() !== "",
  );

const getTranslationValue = (translation, language) => {
  if (!isObject(translation)) {
    return "";
  }

  if (language === "ar") {
    return firstNonEmpty(
      translation.ar,
      translation.Ar,
      translation.arabic,
      translation.Arabic,
      translation.nameAr,
      translation.labelAr,
    );
  }

  return firstNonEmpty(
    translation.en,
    translation.En,
    translation.english,
    translation.English,
    translation.nameEn,
    translation.labelEn,
  );
};

const getPreferredText = (value, language) => {
  if (!value) {
    return "";
  }

  if (typeof value === "string" || typeof value === "number") {
    return String(value);
  }

  if (!isObject(value)) {
    return "";
  }

  const translatedValue =
    getTranslationValue(value, language) ||
    getTranslationValue(value.translation, language) ||
    getTranslationValue(value.Translation, language);
  if (translatedValue) {
    return String(translatedValue);
  }
  if (language === "ar") {
    return String(
      firstNonEmpty(
        value.name_ar,
        value.name_en,
        value.name?.ar,
        value.name,
        value.nameAr,
        value.labelAr,
        value.titleAr,
        value.label,
        value.title,
        value.displayName,
        value.value,
        value.id,
      ) || "",
    );
  }

  return String(
    firstNonEmpty(
      value.name_en,
      value.name_ar,
      value.name?.en,
      value.nameEn,
      value.labelEn,
      value.titleEn,
      value.name,
      value.label,
      value.title,
      value.displayName,
      value.value,
      value.id,
    ) || "",
  );
};

export const toDisplayText = (value, fallback = "") => {
  const fallbackText =
    fallback === undefined || fallback === null ? "" : String(fallback);
  const arabicCandidate = getPreferredText(value, "ar");
  const englishCandidate = getPreferredText(value, "en");

  return (
    firstNonEmpty(
      arabicCandidate,
      englishCandidate,
      typeof value === "string" || typeof value === "number"
        ? String(value)
        : "",
      fallbackText,
    ) || ""
  );
};

export const mapOptionName = (item = {}) => {
  const id =
    firstNonEmpty(
      item.id,
      item.Id,
      item.value,
      item.Value,
      item.code,
      item.Code,
      item.uuid,
    ) || "";
  const arabicName = getPreferredText(item, "ar");
  const englishName = getPreferredText(item, "en");

  return {
    ...item,
    id,
    value: firstNonEmpty(item.value, item.Value, id) || "",
    name:
      firstNonEmpty(arabicName, englishName, item.name, item.label, id) || "",
    nameAr:
      firstNonEmpty(item.nameAr, arabicName, item.name, item.label, id) || "",
    nameEn:
      firstNonEmpty(item.nameEn, englishName, item.name, item.label, id) || "",
  };
};
